<template>
    <v-container>
          <v-row>
              <Data2_1></Data2_1>
          </v-row>
          <v-row>
              <Data2_2></Data2_2>
          </v-row>
          <v-row>
              <Data2_3></Data2_3>
          </v-row>
    </v-container>
  
</template>

<script>

import Data2_1 from './Data2_1'
import Data2_2 from './Data2_2'
import Data2_3 from './Data2_3'
export default {
    name: 'Data2',
    components: {
        Data2_1,
        Data2_2,
        Data2_3
    }
}
</script>